var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20088_26867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9954 6.66602C21.6147 6.66602 6.66211 21.6186 6.66211 39.9994C6.66211 58.3801 21.6147 73.3327 39.9954 73.3327C58.3762 73.3327 73.3288 58.3801 73.3288 39.9994C73.3288 21.6186 58.3762 6.66602 39.9954 6.66602Z",
    fill: "#FFAB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7759 56.6663C42.7759 58.2003 41.5324 59.4439 39.9983 59.4439C38.4642 59.4439 37.2207 58.2004 37.2207 56.6663C37.2207 55.1322 38.4642 53.8887 39.9983 53.8887C41.5324 53.8887 42.7759 55.1322 42.7759 56.6663Z",
    fill: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3932 41.7829C43.41 42.2357 42.7737 43.2275 42.7737 44.3083V45.5555C42.7737 47.0884 41.5322 48.3331 39.9961 48.3331C38.46 48.3331 37.2185 47.0884 37.2185 45.5555V44.3083C37.2185 41.0663 39.1238 38.0944 42.0658 36.7359C44.8962 35.4333 46.9404 31.9746 46.9404 30.2773C46.9404 26.4499 43.8266 23.3331 39.9961 23.3331C36.1656 23.3331 33.0518 26.4499 33.0518 30.2773C33.0518 31.8108 31.8096 33.0555 30.2737 33.0555C28.7378 33.0555 27.4961 31.8108 27.4961 30.2773C27.4961 23.3859 33.1042 17.7773 39.9961 17.7773C46.888 17.7773 52.4961 23.3859 52.4961 30.2773C52.4961 34.0305 49.2404 39.547 44.3932 41.7829Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20088_26867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.6667,
    height: 66.6667,
    fill: "white",
    transform: "translate(6.66602 6.66602)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircleIcon);
export default __webpack_public_path__ + "static/media/tick_circle_icon.5b3f4f038ade6b0609d1e5c847bc46fe.svg";
export { ForwardRef as ReactComponent };